module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAGZJREFUGBmFj0sKgDAMRCelB/BeghvXHk5cuxF6LnuCal8x0IVooGUyL+RjZ9Jq0jGM2tVFTpovaQrAUrRhOEfjweqT3AhBCzkQTddW0BehHTbN9xUR+DaiemJE7KFfAnwWl/2deQP6VD5ctWcARgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-login-2018/yellow_close.png
// module id = 721
// module chunks = 1